import { RDEqipEligibilityConservationCRP } from '@cibo/core'
import { ResourceDetailFeature, ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { SelectRollupEditor } from '../../SelectRollupEditor'
import { EQIP_PRACTICES_CONSERVATION, EqipPracticesConservation } from './types'

export const RDEqipEligibilityConservationCRPResourceDetailFeature: ResourceDetailFeature<RDEqipEligibilityConservationCRP> =
  {
    traitId: 'eqipEligibilityConservationCRP',
    TaskEditor: (props: ResourceDetailFeatureTaskEditorProps<RDEqipEligibilityConservationCRP>) => (
      <SelectRollupEditor<RDEqipEligibilityConservationCRP, readonly EqipPracticesConservation[]>
        options={EQIP_PRACTICES_CONSERVATION}
        detailKey="crpEnrolled"
        ns="@cibo/landmanager/RDEqipEligibilityConservationCRPResourceDetailFeature"
        {...props}
      />
    ),
  }
